//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ref, computed, watch, onBeforeMount,
} from '@vue/composition-api'
import {
  mdiPlus, mdiDeleteOutline, mdiClose, mdiMenuDown, mdiCreditCardOutline,
} from '@mdi/js'
import {
  required,
  minLengthValidator,
  integerValidator,
  emailValidator,
  lengthBetweenValidator,
} from '@core/utils/validation'
import { useUtils } from '@core/libs/i18n'
import { formatCurrency } from '@core/utils'
import usePhone from '@core/utils/usePhone'
import CardValidator from 'card-validator'

import { VueMaskDirective } from 'v-mask'
import Vue from 'vue'

export default {
  name: 'CheckoutPay',
  model: {
    prop: 'isOpen',
    event: 'update:is-open',
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    taxes: {
      type: Number,
      default: 0,
      required: true,
    },
    subtotal: {
      type: Number,
      default: 0,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
      required: true,
    },
    totalFormat: {
      type: String,
      default: 'usd',
      required: true,
    },
    paymentMethods: {
      type: Array,
      required: true,
      default: () => [],
    },
    hasUser: {
      type: Boolean,
      required: true,
      default: false,
    },
    userData: {
      type: [Object, Boolean],
      required: true,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()
    const { phoneCodeOptions } = usePhone()

    const form = ref(null)
    const formData = ref({
      card_number: null,
      card_date: null,
      exp_month: null,
      exp_year: null,
      cvv: null,
      email: null,
      first_name: null,
      last_name: null,
    })
    const saveCreditCard = ref(0)
    const cardData = ref({
      cvc: null,
      expiry: null,
      number: null,
      name: null,
    })
    const selectedCard = ref(0)
    const cardFilter = ref('*')
    const result = computed(() => CardValidator.number(formData.value.card_number))
    const rules = [value => !!value || 'Required', () => result.value.isValid || 'Invalid Card Number']
    const iso = ref(null)
    const mountedIso = ref(false)
    const menu = ref(false)
    const modal = ref(false)
    const date = ref(
      new Date().toLocaleString('sv-SE', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }),
    )
    const currentDate = ref(new Date())
    const currentYear = ref(currentDate.value.getFullYear() - 2000)
    const currentMonth = ref(currentDate.value.getMonth() + 1)

    const logDataComputed = computed(() => props.logData)
    const isPhoneVisible = ref(false)

    const validateExpDate = (mm, yy) => {
      const expirationYear = parseInt(yy, 10)
      const expirationMonth = parseInt(mm, 10)

      if (expirationYear < currentYear.value) {
        return false
      }

      if (expirationYear === currentYear.value && expirationMonth < currentMonth.value) {
        return false
      }

      return true
    }

    const isValidDateRule = value => {
      if (value === null || value === undefined || value === '') {
        return true
      }

      const regex = /^((0[1-9])|(1[0-2]))\/(\d{2})$/
      if (!regex.test(value)) {
        return false
      }

      const dateParts = value.split('/')
      const expirationYear = parseInt(dateParts[1], 10)
      const expirationMonth = parseInt(dateParts[0], 10)

      return validateExpDate(expirationMonth, expirationYear)
    }

    const computedIsOpen = computed(() => props.isOpen)
    const computedPaymentMethods = computed(() => props.paymentMethods)

    const capitalize = text => text
      .split(' ')
      .map(e => `${e.at(0).toUpperCase()}${e.substring(1, e.length)}`)
      .join(' ')

    const cardNumberRule = value => {
      if (!value) return 'Required'
      if (!result.value.isValid) return 'Invalid Card Number'

      return true
    }

    const identifyCard = () => {
      const niceType = result.value?.card?.niceType
      let filter = '*'
      let filterCard = '*'
      if (niceType) {
        const type = niceType.toLowerCase().replace(/\s/g, '')
        filter = `#${type}`
        filterCard = `${type}`
      }

      cardFilter.value = filterCard
      if (iso.value) iso.value.arrange({ filter })
    }

    const onPay = () => {
      let cardInfo = {
        payment_method_id: null,
        payment_intent_id: null,
        save_card: null,
        name: null,
        number: null,
        exp_month: null,
        exp_year: null,
        cvc: null,
        country: null,
        zip_code: null,
      }
      if (!selectedCard.value && form.value.validate()) {
        const [mounth, year] = formData.value.card_date.split('/')
        let fullYear = year

        if (year.length === 2) fullYear = `20${year}`
        cardInfo = {
          payment_method_id: null,
          payment_intent_id: null,
          save_card: props.hasUser ? saveCreditCard.value : 'N',
          name: capitalize(formData.value.card_holder),
          number: formData.value.card_number,
          exp_month: parseInt(mounth, 10),
          exp_year: parseInt(fullYear, 10),
          cvc: formData.value.cvv,
          country: formData.value.country,
          zip_code: formData.value.zip_code,
          email: formData.value.email,
        }
        emit('save', cardInfo)
      } else if (saveCreditCard.value !== 0) {
        cardInfo = {
          payment_method_id: selectedCard.value,
          payment_intent_id: null,
          save_card: null,
          name: null,
          number: null,
          exp_month: null,
          exp_year: null,
          cvc: null,
          country: null,
          zip_code: null,
        }
        emit('save', cardInfo)
      }
    }

    watch([selectedCard], () => {
      if (selectedCard.value !== 0) form.value.reset()

      formData.value.save_credit_card = 'N'
      saveCreditCard.value = 'N'
    })

    watch([computedIsOpen], async () => {
      if (computedIsOpen.value) {
        if (computedPaymentMethods.value.length > 1) {
          selectedCard.value = computedPaymentMethods.value.at(1).id
        } else {
          selectedCard.value = 0
        }
      } else {
        formData.value = {
          card_number: null,
          card_date: null,
          exp_month: null,
          exp_year: null,
          cvv: null,
          name: null,
          email: null,
        }
        form.value.resetValidation()
      }
    })

    onBeforeMount(() => {
      Vue.directive('mask', VueMaskDirective)
    })

    return {
      // data
      form,
      formData,
      cardData,
      cardFilter,
      cardNumberRule,
      selectedCard,
      mountedIso,
      menu,
      modal,
      date,
      saveCreditCard,

      isPhoneVisible,
      logDataComputed,
      phoneCodeOptions,

      // computed
      computedIsOpen,
      computedPaymentMethods,

      // methods
      onPay,
      formatCurrency,
      identifyCard,
      validateExpDate,

      // validations
      required,

      // i18n
      t,

      // validators
      validators: {
        required,
        minLengthValidator,
        integerValidator,
        emailValidator,
        cardNumberRule,
        isValidDateRule,
        lengthBetweenValidator,
        rules,
      },

      // icons
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiClose,
        mdiMenuDown,
        mdiCreditCardOutline,
      },
    }
  },
}
